/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicates that a session was issued, and the application should use this token for authenticated requests
 */
export interface ContinueWithSetOrySessionToken { 
    /**
     * Action will always be `set_ory_session_token` set_ory_session_token ContinueWithActionSetOrySessionTokenString
     */
    action: ContinueWithSetOrySessionToken.ActionEnum;
    /**
     * Token is the token of the session
     */
    ory_session_token: string;
}
export namespace ContinueWithSetOrySessionToken {
    export type ActionEnum = 'set_ory_session_token';
    export const ActionEnum = {
        SetOrySessionToken: 'set_ory_session_token' as ActionEnum
    };
}


